import { Languages } from "@tree-company/collect-js-client";
import { SurveyComponent, Survey } from "@tree-company/tree-query";
import { useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";
import { THEMES } from "../themes";
import translate from "../locales";
import { surveySettingsForTheme } from "../surveys";

// We create a small wrapper component so that we are sure that the theme exists when we render `ThemeSurvey`
export function ThemeSurveyWrapper({ apiClient }) {
  const { theme } = useParams();

  // Redirect back to root if the user went to a url that doesn't exist
  if (THEMES[theme] === undefined) return <Navigate to="/" />;

  return <ThemeSurvey apiClient={apiClient} />;
}

function ThemeSurvey({ apiClient }) {
  const { theme } = useParams();

  const treesponse = useMemo(() => {
    return apiClient.initTreesponse({
      language: Languages.nl,
      surveyVersion: "v5",
      initialAnswers: { theme, bpart_name: translate([theme, "bpart_name"]) },
    });
  }, [theme]);

  const survey = useMemo(() => {
    const survey = new Survey(surveySettingsForTheme(theme), treesponse);
    // If we are on the "like" page and there are only two comments, redirect to next page.
    survey.settings.pages
      .find((page) => page.key === "like")
      .sections.find((section) => section.key === "like").onOptionsLoaded = (
      options,
    ) => {
      if (options.length < 2) {
        survey.nextPage();
      }
    };

    return survey;
  }, [theme]);

  return <SurveyComponent survey={survey} />;
}
